<template xmlns="http://www.w3.org/1999/html">
  <div class="page-scan-in">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">珠海倉庫</div>
      <div class="breadcrumb-item">掃描入庫散件(合作方)</div>
    </div>

    <div class="pg-block">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <div class="pg-form-wrap">
        <Row>
          <Col span="10">
            <Form :label-width="100">
              <!--<FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>录入櫃點</span>
                </div>

                <Select
                  placeholder="請選擇門店"
                  not-found-text="無匹配數據"
                  clearable
                  filterable
                  v-model="arrive2"
                  @on-change="handleArriveSelect2"
                  style="width: 45%"
                >
                  <Option
                    :value="item.ReceivingID"
                    v-for="(item, index) in pickAddress"
                    :key="item.ReceivingID"
                    >({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
                </Select>

                <Select
                  placeholder="請選擇智能櫃"
                  not-found-text="無匹配數據"
                  clearable
                  filterable
                  v-model="arrive_cabinet2"
                  @on-change="handleArriveSelectCabinet2"
                  style="width: 45%; margin-left: 5px"
                >
                  <Option
                    :value="item.ReceivingID"
                    v-for="(item, index) in pickAddress_cabinet2"
                    :key="item.ReceivingID"
                    >({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
                </Select>
              </FormItem>-->

              <!--<FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>袋号</span>
                </div>
                <span style="color: #ff466b; font-size: 18px"
                  >:{{ bagNumber }}</span
                >
                <Button @click="getBagNumber">获取袋号</Button>
              </FormItem>-->
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>包裹类型：</span>
                </div>
                <span v-if="is_pdd" style="font-size: 28px; color: #ff466b"
                  >拼多多包裹</span
                >
                <span v-else style="font-size: 28px; color: #ff466b"
                  >普通包裹</span
                >
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>快遞單號</span>
                </div>
                <Input
                  ref="order_number_ref"
                  v-model="form.odd_numbers"
                  @on-blur="getOddBlur"
                  @on-clear="clearForm"
                  @keyup.enter.native="handleEnter('phone_ref')"
                  clearable
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>澳門手機號/會員號</span>
                </div>
                <Input
                  ref="phone_ref"
                  v-model="form.recipient_phone"
                  @on-blur="getPickAddressByPhone"
                  clearable
                  @keyup.enter.native="handleEnter('wide_ref')"
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>重量</span>
                </div>
                <Input
                  v-model="form.weight"
                  ref="wide_ref"
                  @keyup.enter.native="handleEnter('detailed_name')"
                  @on-blur="handleBlur('weight')"
                  placeholder="KG"
                  clearable
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>快件明細</span>
                </div>
                <Input
                  v-model="form.detailed_name"
                  ref="detailed_name"
                  @keyup.enter.native="handleEnter('packageSize1_ref')"
                  @on-blur="handleBlur('detailed_name')"
                  placeholder="请输入快件明细"
                  clearable
                ></Input>
              </FormItem>
              <!--
							<FormItem>
								<div slot="label" class="form-label">
									<em class="red">* </em>
									<span>快件明細</span>
								</div>
								<Select
										ref="select"
										placeholder="請選擇"
										loading-text="加載中"
										not-found-text="無匹配數據"
										filterable
										:loading="isLoadingDeliver"
										:remote-method="handleSearchDeliverLocalSession"
										@on-query-change="handleQueryChange"
										v-model="form.detailed"
										clearable
										@on-open-change="onDeliverListSelectOpenChange"
										@keyup.enter.native="handleEnter('packageSize1_ref')"
								>
									<Option
											:value="item.id"
											:label="item.name"
											v-for="(item, index) in deliverList"
											:key="item.id"
									>
										{{ item.number }} {{ item.name }} {{ item.pinyin }}
									</Option>
								</Select>
							</FormItem>
								-->
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>尺寸</span>
                </div>
                <div>最長邊少於50cm輸入最長邊即可</div>
                <div style="display: flex">
                  <div>
                    <div slot="label" class="form-label">
                      <span>薄於5cm</span>
                    </div>

                    <Input
                      v-model="packageSize1"
                      ref="packageSize1_ref"
                      @on-blur="getPickByPackageSize('packageSize1')"
                      @keyup.enter.native="handleEnter('packageSize2_ref')"
                      clearable
                    ></Input>
                  </div>
                  <div>
                    <div slot="label" class="form-label">
                      <span>厚於5cm</span>
                    </div>
                    <Input
                      v-model="packageSize2"
                      ref="packageSize2_ref"
                      @on-blur="getPickByPackageSize('packageSize2')"
                      @keyup.enter.native="handleEnter('long_id')"
                      clearable
                    ></Input>
                  </div>
                </div>
                <div>
                  <div slot="label" class="form-label">
                    <span>最長邊大於50cm</span>
                  </div>
                  <div>
                    <div slot="label" class="form-label">
                      <span>長X寬X高</span>
                    </div>
                    <div style="overflow: hidden">
                      <Row :gutter="16">
                        <Col span="8">
                          <Input
                            placeholder="長(CM)"
                            v-model="form.long"
                            ref="long_id"
                            @on-blur="getPickByLong"
                            @keyup.enter.native="onTab1"
                            clearable
                          ></Input>
                        </Col>
                        <Col span="8">
                          <Input
                            placeholder="寬(CM)"
                            v-model="form.wide"
                            ref="wide_id"
                            @on-blur="getPickByWide"
                            @keyup.enter.native="onTab2"
                            clearable
                          ></Input>
                        </Col>
                        <Col span="8">
                          <Input
                            placeholder="高(CM)"
                            v-model="form.height"
                            ref="height_id"
                            @on-blur="getPickByHeight"
                            @keyup.enter.native="onTab3"
                            clearable
                          ></Input>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </FormItem>

              <!--              <FormItem>
															<div slot="label" class="form-label">
																<span>指令錄入</span>
															</div>
															<Input
																	v-model="form.instructions"
																	ref="command_id"
																	@keyup.enter.native="onSubmit"
																	clearable
															></Input>
														</FormItem>-->

              <div style="margin-left: 90px; margin-bottom: 20px">
                <div class="pg-btn-wrap">
                  <div class="pg-btn style1" @click="handlePrintCode">
                    打印條碼
                  </div>

                  <div class="pg-btn style2" @click="handleCheckForm">
                    提交保存
                  </div>
                  <div
                    class="pg-btn"
                    style="margin-top: 20px"
                    @click="testPrint"
                  >
                    test print
                  </div>
                </div>
              </div>

              <!--              <FormItem>
															<div class="form-tip-text">
																<p style="color: black">
																	指令說明：<br/>
																	客戶代碼：4-5位<br/>
																	手機號查找：以+開始<br/>
																	長寬高：以*開始<br/>
																	破損代碼：6位<br/>
																	面單代碼：7位到30位<br/>
																	重量：含有小數點（.）<br/>
																	尺寸：-開頭，（-1；-2；-3）<br/>
																	快件明细：/開頭（/快件）<br/>
																</p>
																<p style="color: red">打印條碼：Ctrl + s</p>
															</div>
														</FormItem>-->
            </Form>
          </Col>

          <Col span="10" offset="1">
            <Form :label-width="100">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>客戶名稱</span>
                </div>
                <Input v-model="form.recipient_contacts" clearable></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>提貨櫃點</span>
                </div>

                <Select
                  placeholder="請選擇門店"
                  not-found-text="無匹配數據"
                  clearable
                  filterable
                  v-model="form.arrive"
                  @on-change="handleArriveSelect"
                  style="width: 45%"
                >
                  <Option
                    :value="item.ReceivingID"
                    v-for="(item, index) in pickAddress"
                    :key="item.ReceivingID"
                    >({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
                </Select>

                <Select
                  placeholder="請選擇智能櫃"
                  not-found-text="無匹配數據"
                  clearable
                  filterable
                  v-model="form.arrive_cabinet"
                  @on-change="handleArriveSelectCabinet"
                  style="width: 45%; margin-left: 5px"
                >
                  <Option
                    :value="item.ReceivingID"
                    v-for="(item, index) in pickAddress_cabinet"
                    :key="item.ReceivingID"
                    >({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>收件方式</span>
                </div>
                <Select placeholder="- - -" v-model="form.arrive_type" disabled>
                  <Option :value="1">門店</Option>
                  <Option :value="2">智能櫃</Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>異常件</span>
                </div>
                <Select placeholder="請選擇" v-model="form.abnormal_id">
                  <Option :value="0">無</Option>
                  <Option
                    :value="item.id"
                    v-for="(item, index) in deliverExc"
                    :key="item.id"
                    :disabled="item.id == 2 || item.title == '食品附加費'"
                  >
                    {{ item.title }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>珠海到付運費 X 1.3</span>
                </div>
                <Input v-model="form.freight_collect" clearable></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>數量</span>
                </div>
                <InputNumber
                  :min="1"
                  v-model="form.count"
                  clearable
                ></InputNumber>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>违禁品</span>
                </div>
                <Input v-model="form.contraband" clearable></Input>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>违禁品百分比%</span>
                </div>
                <Input v-model="form.contraband_percentage" clearable></Input>
              </FormItem>
            </Form>
            <div style="color: #4cc93e; font-size: 32px; margin-bottom: 22px">
              <span style="margin-right: 20px">自动出库</span>
              <Switchs true-color="#51f4a9" v-model="checkedOut" />
            </div>
            <div style="color: #4cc93e; font-size: 32px; margin-bottom: 22px">
              <span style="margin-right: 20px">自动重量</span>
              <Switchs
                true-color="#51f4a9"
                v-model="isopenSerial"
                @on-change="changeSerial"
              />
            </div>
	          <div style="color: #4cc93e; font-size: 32px; margin-bottom: 22px">
              <span style="margin-right: 20px">打印面单</span>
              <Switchs true-color="#51f4a9" v-model="isprint" />
            </div>
            <div
              style="
                font-size: 120px;
                color: #ff9a65;
                font-family: Arial;
                text-align: left;
              "
            >
              <div>${{ counterSum2 }}</div>
            </div>
          </Col>

          <!--<Col span="7">
            <Form :label-width="30">
              <FormItem>
                <Table
                  size="small"
                  max-height="700"
                  border
                  no-data-text="暫無數據"
                  :columns="table.columns"
                  :data="table.data"
                >
                  <template slot-scope="{ row, index }" slot="action">
                    <div>
                      <Button
                        size="small"
                        type="error"
                        @click="handleDeletebag(row)"
                        >删除</Button
                      >
                    </div>
                  </template>
                  <template slot-scope="{ row, index }" slot="is_outbound">
                    <div>
                      <div v-if="row.is_outbound == 1">自动出库</div>
                      <div v-else>未出库</div>
                    </div>
                  </template>
                  <template slot-scope="{ row, index }" slot="detailed_name">
                    <div>
                      <div>{{ row?.detailed_name?.name }}</div>
                    </div>
                  </template>
                </Table>
              </FormItem>
              <FormItem>
                <div style="margin-left: 90px; margin-bottom: 20px">
                  <div class="pg-btn-wrap">
                    <div class="pg-btn style2" @click="handleCheckFormPrint">
                      完成入袋
                    </div>
                  </div>
                </div>
              </FormItem>
            </Form>
          </Col>-->
        </Row>
      </div>
    </div>
	  
	  <!--showMpdel-->
	  <Modal
		  v-model="modalVisible"
		  title="警告"
		  @on-ok="modalVisible = false"
		  @on-cancel="modalVisible = false"
		  cancel-text=""
		  width="400"
	  >
      <p>用户默认地址与当前入件地址不一致.</p>
    </Modal>
    <!--		旧版打印面单-->
    <!--		<PrintInCode ref="print_box"/>-->
    <!--		新版打印面单-->
    <PrintInCode4 ref="print_box" />
    <PrintInCode3 ref="print_box3" />
  </div>
</template>

<script>
import utils from "../../../assets/js/utils";
import { LineBreakTransformer } from "../../../assets/js/LineBreakTransformer";
import PrintInCode from "../../../components/PrintInCode";
import PrintInCode3 from "../../../components/PrintInCode3";
import PrintInCode4 from "../../../components/PrintInCode4";

var port, reader, readableStreamClosed;
export default {
  components: {
    PrintInCode,
    PrintInCode3,
    PrintInCode4,
  },
  data() {
    return {
	    isprint: false,
	    modalVisible: false,
      localdetailList: [],
      deliverListAll: [], //所有快件明細
      deliverList: [], //快件明細，截取
      pickAddress: [], //門店
      pickAddress2: [], //門店
      pickAddress_cabinet: [], //智能櫃
      pickAddress_cabinet2: [], //智能櫃
      packageType: [], //包裹類型
      deliverExc: [], //異常件
      err_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-fail.mp3",
      suc_audio:
        "https://jyb-admin-backend.aoyunltd.com/audio/music-success.mp3",
      isLoadingDeliver: false,
      // arrive_type_status: false,
      form: {
        weight: "", //重量單位g
        odd_numbers: "", //單號
        recipient_phone: "", //澳門手機號
        long: "", //長
        wide: "", //寬
        height: "", //高
        size: 0, //尺寸，1: 厚度小於5cm; 2: 大於5cm
        detailed: "0", //快件明細id
        detailed_name: "",
        instructions: "", //指令
        recipient_contacts: "", //澳門客戶名稱
        arrive: "", //門店
        arrive_cabinet: "", //智能櫃
        // goods_type: '',  //包裹類型id
        arrive_type: "", //收件方式: 1門店，2:智能櫃
        abnormal_id: 0, //異常id
        freight_collect: "", //珠海到付運費
        count: 1, //數量
        contraband: "", // 违禁品
        contraband_percentage: "", // 违禁品百分比
      },
      bagNumber: "",
      isSubmiting: false,
      pdfUrl: "",
      counterSum: 0,
      counterSum2: 0,
      checkedOut: true, // 是否同时出库
      keepReading: true,
      isopenSerial: false,
      deliverListSelectOpened: false,
      print_box: null,
      interception: false,
      arrive2: "",
      arrive_cabinet2: "",
      is_pdd: false,
      table: {
        columns: [
          {
            title: "操作",
            slot: "action",
            align: "center",
          },
          {
            title: "快递单号",
            key: "odd_numbers",
            align: "center",
            minWidth: 80,
          },
          {
            title: "袋号",
            key: "sack_number",
            align: "center",
            width: 100,
          },
          {
            title: "狀態",
            key: "is_outbound",
            slot: "is_outbound",
            align: "center",
          },
          {
            title: "明细",
            slot: "detailed_name",
            key: "detailed_name",
            align: "center",
          },
        ],
        data: [],
      },
      arrive_name2: "",
      packageSize1: "",
      packageSize2: "",
    };
  },
  created() {
    // this.getrecordList();
	  // this.getDeliverList();
	  this.getPackageType();
	  this.getPickAddress();
	  this.getPickAddress_cabinet();
	  this.getDeliverExc();
    // setInterval(() => this.seWeight(Math.random().toFixed(2).toString()),1000)
  },
  async mounted() {
    
    this.$refs?.order_number_ref?.focus();
    // document.addEventListener('keydown',this.keydonwFn)
  },
  activated() {
    document.addEventListener("keydown", this.keydonwFn);
  },
  deactivated() {
    document.removeEventListener("keydown", this.keydonwFn);
  },
  watch: {
    "form.long": function (val, oldVal) {
      if (val) {
        this.packageSize1 = "";
        this.packageSize2 = "";
        this.conunterPrice();
      } else {
        this.counterSum = 0;
        this.counterSum2 = 0;
      }
    },
    "form.wide": function (val, oldVal) {
      if (val) {
        this.packageSize1 = "";
        this.packageSize2 = "";
        this.conunterPrice();
      } else {
        this.counterSum = 0;
        this.counterSum2 = 0;
      }
    },
    "form.height": function (val, oldVal) {
      if (val) {
        this.packageSize1 = "";
        this.packageSize2 = "";
        this.conunterPrice();
      } else {
        this.counterSum = 0;
        this.counterSum2 = 0;
      }
    },
    packageSize1: function (val, oldVal) {
      if (val) {
        this.packageSize2 = "";
        this.form.long = "";
        this.form.wide = "";
        this.form.height = "";
        this.conunterPrice();
      } else {
        this.counterSum = 0;
        this.counterSum2 = 0;
      }
    },
    packageSize2: function (val, oldVal) {
      if (val) {
        this.packageSize1 = "";
        this.form.long = "";
        this.form.wide = "";
        this.form.height = "";
        this.conunterPrice();
      } else {
        this.counterSum = 0;
        this.counterSum2 = 0;
      }
    },
    "form.weight": utils.debounce(function (val, oldVal) {
      console.log(val);
      if (val) {
        this.conunterPrice();
      } else {
        this.counterSum = 0;
        this.counterSum2 = 0;
      }
    }),
    "form.abnormal_id": function (val, oldVal) {
      this.conunterPrice();
    },
    "form.freight_collect": function (val, oldVal) {
      this.conunterPrice();
    },
    "form.contraband_percentage": function (val, oldVal) {
      if (!val) val = 0;
      this.counterSum2 =
        parseFloat(this.counterSum) +
        parseFloat(this.form.contraband) * (parseFloat(val) / 100);
    },
    /* "form.detailed": function (val, oldVal) {
      if (
        val === 6066 ||
        val === 7241 ||
        val === 7441 ||
        val === 7243 ||
        val === 9856
      )
        this.form.abnormal_id = 2;
      else this.form.abnormal_id = 0;
    }, */
  },
  async beforeDestroy() {
    /*if (port) {
				 await this.closeSerial();
				 port = null,reader = null, readableStreamClosed = null
			}*/
  },
  methods: {
    handleEnter(val) {
	    if (this.isSubmiting) {
		    this.modalVisible = false;
		    return false;
	    }
	    if (!this.form.odd_numbers) {
		    this.$refs.order_number_ref?.focus();
		    this.$Utils.showTipInfo("請輸入快遞單號");
		    this.modalVisible = false;
		    return false;
	    }
	    if (!this.form.recipient_phone) {
		    this.$refs.phone_ref?.focus();
		    this.$Utils.showTipInfo("請輸入澳門手機號或會員號碼");
		    this.modalVisible = false;
		    return false;
	    }
	    if (!this.form.weight) {
		    this.$refs.wide_ref?.focus();
		    this.$Utils.showTipInfo("请输入重量");
		    this.modalVisible = false;
		    return false;
	    }
	    if (!this.form.detailed_name) {
		    this.$refs.detailed_name?.focus();
		    this.$Utils.showTipInfo("请输入商品名称");
		    this.modalVisible = false;
		    return false;
	    }
      if (val == "packageSize2_ref") {
	      
        if (this.packageSize1) {
          this.handlePrintCode();
        } else {
          if (this.is_pdd) {
            this.handlePrintCode();
          } else {
            this.$refs[val]?.focus();
          }
        }
      } else if (val == "long_id") {
        if (this.packageSize2) {
          this.handlePrintCode();
        } else {
          if (this.is_pdd) {
            this.handlePrintCode();
          } else {
            this.$refs[val]?.focus();
          }
        }
      } else if (this.is_pdd && val == "detailed_name") {
	      this.$refs["packageSize1_ref"]?.focus();
	      /*if (this.modalVisible) {
		      setTimeout(() =>{
			      this.$refs["wide_ref"]?.focus();
		      },100)
	      }else {
		      this.$refs["packageSize1_ref"]?.focus();
	      }*/
      }/*else if(this.modalVisible && val == 'detailed_name') {
      	setTimeout(() =>{
		      this.$refs["wide_ref"]?.focus();
	      },100)
      }*/else {
        this.$refs[val]?.focus();
      }
	    this.modalVisible = false;
    },
    handleBlur(key) {
      const form = this.form;
      let value = form[key].toString();
      if (value) {
        console.log(value.charAt(value.length - 1));
        if (value.charAt(value.length - 1) == "+") {
          this.form[key] = value.substring(0, value.length - 1) || "";
        }
      }
    },
    handleKeyTab: utils.debounce(function (event, val) {
      console.log("change", event, val);
      const data = event.data;
      if (data == "+") {
        this.$refs[val]?.focus();
      }
    }),
	  clearForm() {
		  this.is_pdd = false;
		  this.interception = false;
		
		  this.packageSize1 = "";
		  this.packageSize2 = "";
		  this.form.weight = ""; // 重量单位g
		  this.form.recipient_phone = ""; // 澳门手机号
		  this.form.long = ""; // 长
		  this.form.wide = ""; // 宽
		  this.form.height = ""; // 高
		  this.form.size = 0; // 尺寸，1: 最长边大于50cm; 2: 小于5cm
		  this.form.detailed = "0"; // 快件明细id
		  this.form.detailed_name = "";
		  this.form.instructions = ""; // 指令
		  this.form.recipient_contacts = ""; // 澳门客户名称
		  this.form.arrive = ""; // 提货柜点
		  this.form.arrive_cabinet = "";
		  this.form.arrive_type = ""; // 收件方式: 1门店，2: 智能柜
		  this.form.abnormal_id = ""; // 异常id
		  this.form.freight_collect = ""; // 珠海到付运费
		  this.form.count = 1; // 数量
		  this.form.contraband = ""; // 违禁品
		  this.form.contraband_percentage = "";
	  },
    handleKeyAdd: utils.debounce(function (event, val) {
      // console.log(event, val);
      const data = event.data;
      // if (data == "+") {
      //   // event.data = data.substring(0, data.length - 1)
      //   // this.$refs[val]?.focus();
      //   if (this.is_pdd && val === "detailed_name") {
      //     this.$refs["packageSize1_ref"]?.focus();
      //   } else {
      //     this.$refs[val]?.focus();
      //   }
      // }
	    if (!data) {
		    if (val == "phone_ref") {
			    this.is_pdd = false;
			    this.interception = false;
			
			    this.packageSize1 = "";
			    this.packageSize2 = "";
			    this.form.weight = ""; // 重量单位g
			    this.form.recipient_phone = ""; // 澳门手机号
			    this.form.long = ""; // 长
			    this.form.wide = ""; // 宽
			    this.form.height = ""; // 高
			    this.form.size = 0; // 尺寸，1: 最长边大于50cm; 2: 小于5cm
			    this.form.detailed = "0"; // 快件明细id
			    this.form.detailed_name = "";
			    this.form.instructions = ""; // 指令
			    this.form.recipient_contacts = ""; // 澳门客户名称
			    this.form.arrive = ""; // 提货柜点
			    this.form.arrive_cabinet = "";
			    this.form.arrive_type = ""; // 收件方式: 1门店，2: 智能柜
			    this.form.abnormal_id = ""; // 异常id
			    this.form.freight_collect = ""; // 珠海到付运费
			    this.form.count = 1; // 数量
			    this.form.contraband = ""; // 违禁品
			    this.form.contraband_percentage = "";
		    }else if (val == 'wide_ref') {
			    this.form.recipient_contacts = ""; // 澳门客户名称
			    this.form.arrive = ""; // 提货柜点
			    this.form.arrive_cabinet = "";
			    this.form.arrive_type = ""; // 收件方式: 1门店，2: 智能柜
		    }
	    }
    }),
    handleCheckFormPrint() {
      if (!this.table.data.length) {
        return this.$message.error("无快件");
      }
      this.$Rq
        .requestAuth({
          method: "post",
          url: this.$Api.scanIn3,
          data: {
            sack_number: this.bagNumber,
          },
        })
        .then((res) => {
          this.$message.info(res.msg);
          if (res.code === 0) {
            const val = {
              count: this.table.data.length,
              sack_number: this.bagNumber,
              store: this.arrive_name2,
            };
            this.$refs.print_box3.printCode(val, (res) => {
              const msg = res == "yes" ? "打印成功" : "打印失败";
              this.$message.info(msg);
              this.getrecordList();
            });
          }
        })
        .catch((err) => {
          this.$message.info(err.msg);
        });
    },
    handleDeletebag(row) {
      const _this = this;
      this.$Modal.confirm({
        title: "警告",
        content: "是否确认移除该快件？",
        onOk: () => {
          _this.$Rq
            .requestAuth({
              method: "post",
              url: _this.$Api.bagNumberdel,
              data: {
                id: row.id,
              },
            })
            .then((res) => {
              _this.$message.info(res.msg);
              if (res.code == 0) {
                _this.getrecordList();
              }
            })
            .catch((err) => {
              this.$message.error("获取包号失败");
            });
        },
        onCancel: () => {},
      });
    },
    getBagNumber() {
      if (this.table.data.length > 0) {
        return this.$Utils.showTipInfo("你有袋子未清点，请先清点后再打印");
      }
      const _this = this;
      this.$Rq
        .requestAuth({
          method: "get",
          url: _this.$Api.getBagNumber,
        })
        .then((res) => {
          _this.$message.info(res.msg);
          if (res.code == 0) {
            _this.bagNumber = res.data.sack_number;
          }
        })
        .catch((err) => {
          _this.$message.error("获取包号失败");
        });
    },
    getrecordList() {
      this.table.data = [];
      this.bagNumber = "";
      this.arrive_name2 = "";
      this.$Rq
        .requestAuth({
          method: "get",
          url: this.$Api.getrecordList,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.table.data = res.data.data;
            if (res.data.data?.length != 0) {
              this.bagNumber = res.data.data[0].sack_number;
              this.arrive_name2 = res.data.arrive_name;
            }
          } else {
            // this.getBagNumber()
          }
        })
        .catch((err) => {
          this.$message.error("获取列表失败");
        });
    },
    keydonwFn(event) {
      // console.log(event, event.keyCode);
      if (event.ctrlKey && event.keyCode === 83) {
        this.handlePrintCode();
      }
    },
    async serial() {
      // 浏览器支持serial
      if ("serial" in navigator) {
        try {
          // 提示用户选择一个串口
          port = await navigator.serial.requestPort();
          this.open();
        } catch (e) {
          this.$message.warning("用户取消选择串口");
          this.isopenSerial = false;
          console.log(e);
        }
      } else {
        alert("你的浏览器不支持串口连接");
      }
    },
    // 打开串口
    async open() {
      // 等待串口打开
      try {
        await port.open({ baudRate: 9600 });
        console.log("串口打开成功", port);

        if (port.readable) {
          this.$message.success("串口打开成功");
          this.isopenSerial = true;
          this.keepReading = true;
          await this.getWeight();
        } else {
          this.isopenSerial = false;
          this.$message.success("串口打开失败");
        }
      } catch (e) {
        this.isopenSerial = false;
        await this.closeSerial();
        (port = null), (reader = null), (readableStreamClosed = null);
        this.$message.warning("串口关闭");
      }
    },
    // 获取重量
    async getWeight() {
      if (!port.readable.locked) {
        const textDecoder = new TextDecoderStream();
        readableStreamClosed = port.readable.pipeTo(textDecoder.writable);
        reader = textDecoder.readable
          .pipeThrough(new TransformStream(new LineBreakTransformer()))
          .getReader();
      }

      while (port.readable && this.keepReading) {
        try {
          while (true) {
            const { value, done } = await reader.read();
            if (done) {
              // reader.releaseLock()
              break;
            }
            // console.log(value)
            const pattern = /[0-9.]*kg/gi;
            const match = value.match(pattern);
            const weightString = match?.[0] || "0.000kg";
            const weight = weightString.replace("kg", "");
            this.seWeight(weight);
          }
        } catch (e) {
          console.log(e);
        } finally {
          await reader.releaseLock();
        }
      }
      await port.close();
    },

    seWeight: utils.throttle(function (weight) {
      // console.log(weight)
      this.form.weight = weight;
    }, 100),

    // 关闭串口
    async closeSerial() {
      try {
        this.keepReading = false;
        await port.forget();
        await reader.cancel();
        this.form.weight = "";
        this.$message.warning("串口关闭");
      } catch (e) {
        console.log(e);
      } finally {
        window.location.reload();
      }
    },

    changeSerial(e) {
      if (e) {
        this.serial();
      } else {
        this.closeSerial();
      }
    },
    computedPackageSize() {
      return 0 | 1 | 2;
    },
    conunterPrice() {
      let { form } = this.$data;
      let size = 0;
      let long = form.long.toString();

      if (this.packageSize1) {
        size = 1;
        long = this.packageSize1.toString();
      } else if (this.packageSize2) {
        size = 2;
        long = this.packageSize2.toString();
      }
      if (long.charAt(long.length - 1) == "+") {
        long = long.substring(0, long.length - 1) || "";
      }

      let wide = form.wide.toString();
      if (wide.charAt(wide.length - 1) == "+") {
        wide = wide.substring(0, wide.length - 1) || "";
      }

      let height = form.height.toString();
      if (height.charAt(height.length - 1) == "+") {
        height = height.substring(0, height.length - 1) || "";
      }

      let weight = form.weight.toString();
      if (weight.charAt(weight.length - 1) == "+") {
        weight = weight.substring(0, weight.length - 1) || "";
      }

      let data = {
        long,
        wide,
        height,
        weight,
        size,
        abnormal_id: form.abnormal_id,
        freight_collect: form.freight_collect,
      };
      if (data.size == 0) {
        this.counterSum = 0;
        this.counterSum2 = 0;
        if (data.long && data.wide && data.height && data.weight) {
          this.setCounter(data);
        }
      } else if (data.size == 1 || data.size == 2) {
        if (data.long && data.weight) {
          this.setCounter(data);
        }
      }
    },
    setCounter(data) {
      if (data.abnormal_id == 0) {
        data.abnormal_id = "";
      }
      this.$Rq
        .requestAuth({
          method: "post",
          url: this.$Api.counterSums,
          data,
        })
        .then((res) => {
          this.counterSum = res.data.amount || 0;
          this.counterSum2 = res.data.amount || 0;
        })
        .catch((err) => {
          this.counterSum = 0;
          this.counterSum2 = 0;
        });
    },
    onTab1() {
	    this.modalVisible = false;
      this.$refs.wide_id.focus();
      //@keyup.native="handleKeyAdd('long_id')"
    },
    onTab2() {
	    this.modalVisible = false;
      this.$refs.height_id.focus();
      //@keyup.native="handleKeyAdd('long_id')"
    },
    onTab3() {
	    this.modalVisible = false;
      if (this.form.height && this.form.long && this.form.wide) {
        this.handlePrintCode();
      } else if (this.is_pdd) {
        this.handlePrintCode();
      } else {
        this.$refs.long_id?.focus();
      }
    },
    getOddBlur() {
      if (this.form.odd_numbers == "") {
        return false;
      }
      // let val = this.form.odd_numbers.toString();
      // if (val) {
      //   console.log(val.charAt(val.length - 1));
      //   if (val.charAt(val.length - 1) == "+") {
      //     this.form.odd_numbers = val.substring(0, val.length - 1) || "";
      //   }
      // }
      this.getItem();
    },
    getItem() {
	    if (this.isSubmiting) {
		    return false;
	    }
      this.interception = false;
      this.is_pdd = false;
      this.$Rq
        .requestAuth({
          url: this.$Api.isorder,
          method: "get",
          data: {
            order: this.form.odd_numbers,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.$Utils.showTipInfo("該單號已存在");
            let audio = new Audio();
            audio.src = this.err_audio;
            audio.play();
            this.form.odd_numbers = "";
            this.$refs.order_number_ref?.focus()
          } else if (res.code == 3) {
            this.interception = true;
	          this.$Utils.showTipInfo(`該單號已被拦截，请联系客服处理，拦截原因：${res.msg}`);
            let audio = new Audio();
            audio.src = this.err_audio;
            audio.play();
	          this.form.odd_numbers = "";
            this.$refs.order_number_ref?.focus();
          } else if (res.code == 1 && res.data.goods_name) {
            
            this.is_pdd = true;
	
	          if (res.data.is_del == 1) {
		          this.$Utils.showTipInfo("该包裹为拼多多退货件，请退回");
		          let audio = new Audio();
		          audio.src = this.err_audio;
		          audio.play();
		          this.form.odd_numbers = "";
		          this.$refs.order_number_ref?.focus();
		          return false;
	          }
            
            this.$refs.wide_ref?.focus();
            
	          if (res.data.stationcode) {
		          const store = [...this.pickAddress2,...this.pickAddress_cabinet2].find(it => it.cainiao_match == res.data.stationcode)
		          if (store) {
			          if (store.Type == 1) {
				          this.form.arrive = store.ReceivingID
				          this.form.arrive_cabinet = "";
				          this.form.arrive_type = store.Type
				          // this.arrive_type_status = true;
			          } else if (store.Type == 2) {
				          this.form.arrive = "";
				          this.form.arrive_cabinet = store.ReceivingID
				          this.form.arrive_type = store.Type
			          }
			          this.form.detailed_name = res.data.goods_name;
			          this.form.recipient_phone = res.data.mobile;
			          this.form.recipient_contacts = res.data.name;
		          }else {
			          this.form.detailed_name = res.data.goods_name;
			          this.form.recipient_phone = res.data.mobile;
			          this.form.recipient_contacts = res.data.name;
			          // this.getPickAddressByPhone();
		          }
	          }else {
		          this.form.detailed_name = res.data.goods_name;
		          this.form.recipient_phone = res.data.mobile;
		          this.form.recipient_contacts = res.data.name;
		          // this.getPickAddressByPhone();
	          }
           
          } else {
            // this.$refs.phone_ref?.focus();
          }
        });
    },
    onSubmit() {
      // +手机号
      if (this.form.instructions.charAt(0) == "+") {
        this.form.recipient_phone = this.form.instructions.substr(1);
        this.form.instructions = "";
        this.getPickAddressByPhone();
        return false;
      }

      // .重量
      if (this.form.instructions.indexOf(".") != -1) {
        if (this.form.instructions.charAt(0) == ".") {
          this.form.weight = this.form.instructions.substr(1);
        } else {
          this.form.weight = this.form.instructions;
        }
        this.form.instructions = "";
        return false;
      }
      // t长宽高
      /*if (this.form.instructions.charAt(0) == '*') {
				if (!this.form.long) {
					this.form.long = this.form.instructions.substr(1)
					this.form.instructions = ''
					return false
				} else {
					if (this.form.size == 0) {
						if (!this.form.wide) {
							this.form.wide = this.form.instructions.substr(1)
							this.form.instructions = ''
							return false
						} else {
							if (!this.form.height) {
								this.form.height = this.form.instructions.substr(1)
								this.form.instructions = ''
								return false
							}
						}
					} else {
						this.form.long = this.form.instructions.substr(1)
						this.form.instructions = ''
						return false
					}
				}
			}*/
      // 客户代码 4-5
      if (
        this.form.instructions.length <= 6 &&
        this.form.instructions.length >= 4 &&
        this.form.instructions.charAt(0) != "/" &&
        this.form.instructions.charAt(0) != "-" &&
        this.form.instructions.charAt(0) != "." &&
        this.form.instructions.charAt(0) != "*"
      ) {
        this.form.recipient_phone = this.form.instructions.substr(0);
        this.form.instructions = "";
        this.getPickAddressByPhone();
        return false;
      }
      // 快递单号
      if (
        this.form.instructions.length > 6 &&
        this.form.instructions.length < 31
      ) {
        this.form.odd_numbers = this.form.instructions;
        this.getOdd();
        this.form.instructions = "";
        return false;
      }
      // 快件类型 -1 默认 -2厚度小于5 -3厚度大于5
      /*if (this.form.instructions.charAt(0) == '-') {
				if (this.form.instructions == '-1') {
					this.form.size = 0
					this.form.long = ''
					this.form.wide = ''
					this.form.height = ''
				} else if (this.form.instructions == '-2') {
					this.form.size = 1
					this.form.wide = ''
					this.form.height = ''
				} else if (this.form.instructions == '-3') {
					this.form.size = 2
					this.form.wide = ''
					this.form.height = ''
				}
				this.form.instructions = ''
			}*/

      // /xx搜索商品详情
      /*if (this.form.instructions.charAt(0) == '/') {
					let value = this.form.instructions.substr(1)
					this.handleSearchDeliverLocalSession(value)
					setTimeout(() => {
							this.$refs.select.visible = true
							this.$refs.select.isFocused = true
					}, 500)
					this.form.instructions = ''
			}*/
    },
    //快件明細
    getDeliverList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.deliverList,
          method: "get",
          data: {
            /* offset: 0,
									limit: 200,
									keywords: ''*/
          },
        })
        .then((res) => {
          if (res.code == 0) {
            let resData = res.data.data;
            this.deliverListAll = resData;
            // this.deliverList = resData.slice(0, 100);
            this.deliverList = resData;
            this.localdetailList = resData;
            sessionStorage.setItem(
              "jyb_detailed",
              JSON.stringify(this.localdetailList)
            );
          }
        });
    },
    //包裹類型
    getPackageType() {
      this.$Rq
        .requestAuth({
          url: this.$Api.packageType,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.packageType = res.data.data;
          }
        });
    },
    //門店
    getPickAddress() {
    	const userInfo = localStorage.getItem("jyb_logInfo") ? JSON.parse(localStorage.getItem("jyb_logInfo")) : {}
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: userInfo.parent_id,
            type: 1,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress = res.data.data.filter(it=>it.company_id != 15);
            this.pickAddress2 = res.data.data.filter(it=>it.company_id != 15);
          }
        });
    },

    //智能櫃
    getPickAddress_cabinet() {
	    const userInfo = localStorage.getItem("jyb_logInfo") ? JSON.parse(localStorage.getItem("jyb_logInfo")) : {}
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: userInfo.parent_id,
            type: 2,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress_cabinet = res.data.data.filter(it=>it.company_id != 15);;
            this.pickAddress_cabinet2 = res.data.data.filter(it=>it.company_id != 15);;
          }
        });
    },
    //異常件
    getDeliverExc() {
      this.$Rq
        .requestAuth({
          url: this.$Api.deliverExc,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.deliverExc = res.data.data;
          }
        });
    },
    //根據手機號獲取提貨櫃點,以及客戶名稱
    getPickAddressByPhone() {
	    if (this.isSubmiting) {
		    return false;
	    }
	    
      let form = this.form;

      if (form.recipient_phone !== "") {
        let val = form.recipient_phone.toString();
        // if (val) {
        //   console.log(val.charAt(val.length - 1));
        //   if (val.charAt(val.length - 1) == "+") {
        //     this.form.recipient_phone = val.substring(0, val.length - 1) || "";
        //   }
        // }

        this.$Rq
          .requestAuth({
            url: this.$Api.getInfoByPhone + "/" + form.recipient_phone,
            method: "get",
          })
          .then((res) => {
            
            if (res.code == 0) {
              if (res.data.length == 0) {
	              let audio = new Audio();
	              audio.src = this.err_audio;
	              audio.play();
                this.$Utils.showTipInfo("用戶不存在");
	              this.form.recipient_contacts = "";
	              this.form.recipient_phone = "";
	              this.form.arrive = "";
	              this.form.arrive_cabinet = "";
	              this.form.arrive_type = "";
	              this.$refs.phone_ref?.focus();
                return false;
              }
              // this.$refs.wide_ref?.focus();
	            
	            let resData = res.data || {};
	            this.form.recipient_contacts = resData.user_id
		            ? resData.user_name
		            : "";
	            this.form.recipient_phone = resData.user_id
		            ? resData.phone
		            : ""; // 會員號碼 match 電話號碼
	
	            const store_type = res.data?.receiving?.ReceivingID  ?  res.data.receiving.Type : undefined;
	            if(store_type) {
		            if (store_type == 1) {
			            this.form.arrive = resData.receiving
				            ? resData.receiving.ReceivingID
				            : "";
			            this.form.arrive_cabinet = "";
			            this.form.arrive_type = resData.receiving
				            ? resData.receiving.Type
				            : "";
			            // this.arrive_type_status = true;
		            } else if (store_type == 2) {
			            this.form.arrive = "";
			            this.form.arrive_cabinet = resData.receiving
				            ? resData.receiving.ReceivingID
				            : "";
			            this.form.arrive_type = resData.receiving
				            ? resData.receiving.Type
				            : "";
		            }  else {
			            this.form.arrive = "";
			            this.form.arrive_cabinet = "";
			            this.form.arrive_type = "";
		            }
	            }
              

              console.log(
                this.form.arrive,
                this.form.arrive_cabinet,
              );
	
	            if (res.data.receiving.ReceivingID) {
		            const flag = [...this.pickAddress2, ...this.pickAddress_cabinet2].find(it => it.ReceivingID == res.data.receiving.ReceivingID);
		            if(!flag) {
			            this.form.arrive = "";
			            this.form.arrive_cabinet = "";
			            this.form.arrive_type = "";
		            }
	            }
              /*const store = this.form.arrive ? this.form.arrive : null;
              const store2 = this.form.arrive_cabinet
                ? this.form.arrive_cabinet
                : null;
              const store3 = this.arrive2 ? this.arrive2 : null;
              const store4 = this.arrive_cabinet2 ? this.arrive_cabinet2 : null;

              if (store != store3 || store2 != store4) {
	              if (store || store2) {
		              this.form.arrive = this.arrive2
		              this.form.arrive_cabinet = this.arrive_cabinet2
		              this.arrive_type = this.arrive2 ? 1 : 2
	              }
	             
	              if (!this.modalVisible) {
		              let audio = new Audio();
		              audio.src = this.err_audio;
		              audio.play();
		              /!* this.$Modal.warning({
		               title: "警告",
		               content: "用户默认地址与当前入件地址不一致",
		               });*!/
		              this.modalVisible = true;
		              /!*setTimeout(()=>{
		              	this.$refs.wide_ref.focus()
		              },100)*!/
	              }
              }*/
            }else {
	            this.form.recipient_contacts = "";
	            this.form.recipient_phone = "";
	            this.form.arrive = "";
	            this.form.arrive_cabinet = "";
	            this.form.arrive_type = "";
            }
          });
      } else {
        // this.form.recipient_contacts = "";
        // this.form.arrive = "";
        // this.form.arrive_cabinet = "";
	      // this.form.arrive_type = "";
      }
    },
    getPickByPackageSize(key) {
      const val = Number(this.packageSize1) || Number(this.packageSize2);
      if (val > 40 && this.form.arrive_type == 2) {
        this.form.abnormal_id = 1;
      } else {
        this.form.abnormal_id = 0;
      }

      let value = this[key].toString();
      if (value) {
        console.log(value.charAt(value.length - 1));
        if (value.charAt(value.length - 1) == "+") {
          this[key] = value.substring(0, value.length - 1) || "";
        }
      }
    },
    //根據长度识别异常件
    getPickByLong() {
      let long = this.form.long;
      if (parseFloat(long) > 40 && this.form.arrive_type == 2) {
        this.form.abnormal_id = 1;
      } else {
        this.form.abnormal_id = 0;
      }
      let value = long.toString();
      if (value) {
        console.log(value.charAt(value.length - 1));
        if (value.charAt(value.length - 1) == "+") {
          this.form.long = value.substring(0, value.length - 1) || "";
        }
      }
    },
    getPickByWide() {
      console.log("blur");
      let wide = this.form.wide;
      if (wide > 40 && this.form.arrive_type == 2) {
        this.form.abnormal_id = 1;
      } else {
        this.form.abnormal_id = 0;
      }
      let value = wide;
      console.log(value.charAt(value.length - 1));
      if (value.charAt(value.length - 1) == "+") {
        this.form.wide = value.substring(0, value.length - 1) || "";
      }
    },
    getPickByHeight() {
      let height = this.form.height;
      if (height > 40 && this.form.arrive_type == 2) {
        this.form.abnormal_id = 1;
      } else {
        this.form.abnormal_id = 0;
      }
      let value = height;
      console.log(value.charAt(value.length - 1));
      if (value.charAt(value.length - 1) == "+") {
        this.form.height = value.substring(0, value.length - 1) || "";
      }
    },

    handleQueryChange(value) {
      if (value === "") {
        // this.deliverList = this.deliverListAll.slice(0, 100);
        this.deliverList = this.deliverListAll;
      }
    },
    handleSearchDeliver(value) {
      this.isLoadingDeliver = true;
      this.deliverList = [];
      this.$Rq
        .requestAuth({
          url: this.$Api.deliverList,
          method: "get",
          data: {
            /* offset: 0,
									limit: 200,*/
            keywords: value,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.isLoadingDeliver = false;
            this.$nextTick(() => {});
            this.deliverList = res.data.data;
          }
        })
        .catch((err) => {
          this.isLoadingDeliver = false;
        });
    },

    //快件下拉搜索LocalSession
    /*handleSearchDeliverLocalSession(value) {
				let deliverListAll = JSON.parse(sessionStorage.getItem('jyb_detailed'))
				this.isLoadingDeliver = true
				let queryData = deliverListAll.filter((item) => {
						return (
								item.name.indexOf(value) > -1 ||
								(item.number && item.number.toString().indexOf(value) > -1) ||
								item.pinyin.toLowerCase().indexOf(value.toLowerCase()) > -1
						)
				})
				this.$nextTick(() => {
						this.deliverList = queryData
				})
				this.isLoadingDeliver = false
		},*/

    //門店選擇
    handleArriveSelect(value) {
      if (
        value == undefined &&
        this.form.arrive == undefined &&
        (this.form.arrive_cabinet != undefined ||
          this.form.arrive_cabinet != "" ||
          this.form.arrive_cabinet != null)
      ) {
        return;
      }

      if (
        value == undefined &&
        this.form.arrive == undefined &&
        this.form.arrive_cabinet == undefined
      ) {
        return;
      }

      let pickAddress = this.pickAddress;
      let index = null;
      for (let i = 0; i < pickAddress.length; i++) {
        if (value == pickAddress[i].ReceivingID) {
          index = i;
          break;
        }
      }
      // this.arrive_type_status = true;
      this.form.arrive = value;
      this.form.arrive_type = pickAddress[index].Type; //Type 1門店, 2智能櫃
      this.form.arrive_cabinet = "";
    },

    //門店選擇
    handleArriveSelect2(value) {
      if (
        value == undefined &&
        this.arrive2 == undefined &&
        (this.arrive_cabinet2 != undefined ||
          this.arrive_cabinet2 != "" ||
          this.arrive_cabinet2 != null)
      ) {
        return;
      }

      if (
        value == undefined &&
        this.arrive2 == undefined &&
        this.arrive_cabinet2 == undefined
      ) {
        return;
      }

      let pickAddress = this.pickAddress2;
      let index = null;
      for (let i = 0; i < pickAddress.length; i++) {
        if (value == pickAddress[i].ReceivingID) {
          index = i;
          break;
        }
      }
      // this.arrive_type_status = true;
      this.arrive2 = value;
      this.arrive_cabinet2 = "";
    },

    //智能櫃選擇
    handleArriveSelectCabinet(value) {
      if (
        value == undefined &&
        this.form.arrive_cabinet == undefined &&
        (this.form.arrive != undefined ||
          this.form.arrive != "" ||
          this.form.arrive != null)
      ) {
        return;
      }

      if (
        value == undefined &&
        this.form.arrive_cabinet == undefined &&
        this.form.arrive == undefined
      ) {
        return;
      }

      let pickAddress = this.pickAddress_cabinet;
      let index = null;
      for (let i = 0; i < pickAddress.length; i++) {
        if (value == pickAddress[i].ReceivingID) {
          index = i;
          break;
        }
      }
      // this.arrive_type_status = true;
      this.form.arrive_cabinet = value;
      this.form.arrive_type = pickAddress[index].Type; //Type 1門店, 2智能櫃
      this.form.arrive = "";
    },
    handleArriveSelectCabinet2(value) {
      if (
        value == undefined &&
        this.arrive_cabinet2 == undefined &&
        (this.arrive2 != undefined ||
          this.arrive2 != "" ||
          this.arrive2 != null)
      ) {
        return;
      }

      if (
        value == undefined &&
        this.arrive_cabinet2 == undefined &&
        this.arrive2 == undefined
      ) {
        return;
      }

      let pickAddress = this.pickAddress_cabinet2;
      let index = null;
      for (let i = 0; i < pickAddress.length; i++) {
        if (value == pickAddress[i].ReceivingID) {
          index = i;
          break;
        }
      }
      // this.arrive_type_status = true;
      this.arrive_cabinet2 = value;
      this.arrive2 = "";
    },

    //提交
    handleCheckForm() {
      let form = this.form;

      if (this.interception) {
        return this.$Utils.showTipInfo(
          "入库失败，包裹被拦截，请联系仓管或客服处理"
        );
      }

      const store3 = form.arrive ? form.arrive : null;
      const store4 = form.arrive_cabinet ? form.arrive_cabinet : null;

      if (!store3 && !store4) {
        let audio = new Audio();
        audio.src = this.err_audio;
        audio.play();
        return this.$Utils.showTipInfo("请选择入件地址");
      }
      /*if (!this.bagNumber) {
        return this.$Utils.showTipInfo("包裹编号不能为空");
      }*/
      if (form.weight == "" || form.weight == 0) {
	      this.$refs.wide_ref?.focus();
        this.$Utils.showTipInfo("請輸入重量");
        return;
      }
      if (form.odd_numbers == "") {
      	this.$refs.order_number_ref?.focus();
        this.$Utils.showTipInfo("請輸入快遞單號");
        return;
      }
      if (form.recipient_phone == "") {
      	this.$refs.phone_ref?.focus();
        this.$Utils.showTipInfo("請輸入澳門手機號或會員號碼");
        return;
      }

      //校验长宽高
      if (
        !this.is_pdd &&
        !this.packageSize1 &&
        !this.packageSize2 &&
        !this.form.long &&
        !this.form.wide &&
        !this.form.height
      ) {
      	this.$refs.packageSize1_ref?.focus()
        this.$Utils.showTipInfo("請輸入尺寸");
        return;
      }
      let long = form.long;
      let wide = form.wide;
      let height = form.height;

      if (!this.is_pdd) {
        if (!this.packageSize1 && !this.packageSize2) {
          if (!long || !wide || !height) {
            return this.$Utils.showTipInfo("請輸入長寬高");
          }
          const max = Math.max(Number(long), Number(wide), Number(height));

          if (max < 51) return this.$Utils.showTipInfo("輸入的尺寸不合規則");
        } else {
          const val = Number(this.packageSize1) || Number(this.packageSize2);
          if (!val || val === 0) {
            this.$Utils.showTipInfo("請輸入最長邊");
            return false;
          }

          if (!(val >= 1 && val <= 50)) {
            this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
            return false;
          }
        }
      } else {
        let flag = 0,
          flag2 = 0,
          flag3 = 0;
        if (this.packageSize1) {
          flag = this.packageSize1;
          if (!(flag >= 1 && flag <= 50)) {
            this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
            return false;
          }
        } else if (this.packageSize2) {
          flag = this.packageSize2;
          if (!(flag >= 1 && flag <= 50)) {
            this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
            return false;
          }
        } else {
          flag = form.long;
          flag2 = form.wide;
          flag3 = form.height;

          if (flag && flag2 && flag3) {
            const max = Math.max(Number(flag), Number(flag2), Number(flag3));
            if (max < 51) return this.$Utils.showTipInfo("輸入的尺寸不合規則");
          }
        }
      }

      if (form.detailed_name == "") {
      	this.$refs.detailed_name?.focus()
        this.$Utils.showTipInfo("請選擇快件明細");
        return;
      }
      if (form.recipient_contacts == "") {
        this.$Utils.showTipInfo("請輸入客戶名稱");
        return;
      }
      if (form.arrive == "" && form.arrive_cabinet == "") {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == null && form.arrive_cabinet == null) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == undefined && form.arrive_cabinet == undefined) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }

      this.handleSubmit();
      this.$refs.order_number_ref.focus();
    },

    handleSubmit() {
      let form = this.form;

      let shop_arrive = form.arrive;
      if (
        shop_arrive == null ||
        shop_arrive == "" ||
        shop_arrive == undefined
      ) {
        shop_arrive = form.arrive_cabinet;
      }
      const arr1 = [...this.pickAddress, ...this.pickAddress_cabinet];
      const flag = arr1.find((item) => item.ReceivingID == shop_arrive);
      let size = 0;
      let long = form.long || "";
      let wide = form.wide || "";
      let height = form.height || "";

      if (this.packageSize1) {
        size = 1;
        long = this.packageSize1;
        wide = 0;
        height = 0;
        if (!(long >= 1 && long <= 50)) {
          this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
          return false;
        }
      } else if (this.packageSize2) {
        size = 2;
        long = this.packageSize2;
        wide = 0;
        height = 0;
        if (!(long >= 1 && long <= 50)) {
          this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
          return false;
        }
      } else {
        size = 0;
        long = form.long;
        wide = form.wide;
        height = form.height;

        if (long && wide && height) {
          const max = Math.max(Number(long), Number(wide), Number(height));
          if (max < 51) return this.$Utils.showTipInfo("輸入的尺寸不合規則");
        }
      }
      
      this.isSubmiting = true;
      const params = {
        weight: Number(form.weight) < 0.01 ? 0.01 : Number(form.weight),
        odd_numbers: form.odd_numbers,
        recipient_phone: form.recipient_phone,
        long: Number(long),
        wide: Number(wide),
        height: Number(height),
        size: size,
        detailed: Number(form.detailed),
        detailed_name: form.detailed_name,
        instructions: form.instructions,
        recipient_contacts: form.recipient_contacts,
        arrive: shop_arrive,
        // goods_type: Number(form.goods_type),
        arrive_type: Number(form.arrive_type) ? Number(form.arrive_type) : 1, // 取货方式 1:门店取货; 2:智能柜取货
        abnormal_id: form.abnormal_id ? Number(form.abnormal_id) : 0,
        freight_collect: Math.round(Number(form.freight_collect) * 1.3),
        count: Number(form.count),
        contraband: Number(form.contraband),
        contraband_percentage: Number(form.contraband_percentage),
        // sack_number: this.bagNumber,
        is_outbound: this.checkedOut ? 1 : 0,
        // remarks: "入库",
      };
      console.log(params, flag);
      this.$Rq
        .requestAuth({
          url: this.$Api.scanIn,
          method: "post",
          data: params,
        })
        .then((res) => {
	        this.is_pdd = false;
	        
	        if (res.code == 0) {
		        
		        this.print_war();
		        if (res.msg == "入庫成功!") {
			        if (this.checkedOut || flag.north_pick_up == 1) {
				        // 同时出库
				        this.$Rq
					        .requestAuth({
						        url: this.$Api.scanOut,
						        method: "post",
						        data: {
							        sack_number: form.odd_numbers,
							        odd_numbers: form.odd_numbers,
							        // arrive_type: form.arrive_type, //1是門店，2是智能櫃,
							        arrive: shop_arrive, //門店或智能櫃id
							        type: 1,
						        },
					        })
					        .then((re) => {
						        if (flag.north_pick_up == 1) {
							        this.$Utils.showSuccess(`----${res.msg}----${re.msg}`);
						        }else {
							        this.$Utils.showSuccess(
								        `大件----${res.msg}--大件--${re.msg}`
							        );
						        }
						        
						        let audio = new Audio();
						        audio.src = this.suc_audio;
						        audio.play();
					        })
					        .catch((er) => this.$Utils.showTipInfo(er.msg));
			        }
		        } else {
			        this.$Utils.showSuccess(res.msg);
			        let audio = new Audio();
			        audio.src = this.err_audio;
			        audio.play();
		        }
		
		        // this.deliverList = this.deliverListAll.slice(0, 100);
		        // this.deliverList = this.deliverListAll;
		        this.packageSize1 = "";
		        this.packageSize2 = "";
		        this.form = {
			        weight: "", //重量單位g
			        odd_numbers: "", //單號
			        recipient_phone: "", //澳門手機號
			        long: "", //長
			        wide: "", //寬
			        height: "", //高
			        // size: this.form.size, //尺寸，1: 最長邊大於50cm; 2: 小於5cm
			        size: 0, //尺寸，1: 最長邊大於50cm; 2: 小於5cm
			        detailed: "", //快件明細id
			        detailed_name: "", //快件明細id
			        instructions: "", //指令
			        recipient_contacts: "", //澳門客戶名稱
			        arrive: "", //提貨櫃點
			        arrive_cabinet: "",
			        // goods_type: '',  //包裹類型id
			        arrive_type: "", //收件方式: 1門店，2:智能櫃
			        abnormal_id: "", //異常id
			        freight_collect: "", //珠海到付運費
			        count: 1, //數量
			        contraband: "", //违禁品
			        contraband_percentage: "",
		        };
	        } else {
		        let audio = new Audio();
		        audio.src = this.err_audio;
		        audio.play();
		        this.$Utils.showTipInfo(res.msg);
	        }
	        setTimeout(() => {
		        this.isSubmiting = false;
	        },200)
        })
        .catch((err) => {
          let audio = new Audio();
          audio.src = this.err_audio;
          audio.play();
	        setTimeout(() => {
		        this.isSubmiting = false;
	        },200)
        })
        .finally(() => {
	        setTimeout(() => {
		        this.isSubmiting = false;
	        },200)
        });
    },
    print_war() {
      console.log("打印");
	    if (!this.isprint) {
		    return
	    }
      const form = this.form;
      let shop_arrive = form.arrive;
      if (
        shop_arrive == null ||
        shop_arrive == "" ||
        shop_arrive == undefined
      ) {
        shop_arrive = form.arrive_cabinet;
      }
      this.$refs.print_box.printCode(
        {
          order: form.odd_numbers,
          user_phone: form.recipient_phone,
          store_id: shop_arrive,
        },
        (res) => {
          res == "yes"
            ? this.$Message.success("打印成功")
            : this.$Message.error("打印失败");
        }
      );
    },

    testPrint() {
      this.$refs.print_box.testPrint();
    },
    //打印條碼
    handlePrintCode() {
      let form = this.form;

      if (this.interception) {
        return this.$Utils.showTipInfo(
          "入库失败，包裹被拦截，请联系仓管或客服处理"
        );
      }

      const store3 = form.arrive ? form.arrive : null;
      const store4 = form.arrive_cabinet ? form.arrive_cabinet : null;

      if (!store3 && !store4) {
        let audio = new Audio();
        audio.src = this.err_audio;
        audio.play();
        return this.$Utils.showTipInfo("请选择入件地址");
      }
      /*if (!this.bagNumber) {
        return this.$Utils.showTipInfo("包裹编号不能为空");
      }*/
      if (form.weight == "" || form.weight == 0) {
      	this.$refs.wide_ref?.focus();
        this.$Utils.showTipInfo("請輸入重量");
        return;
      }
      if (form.odd_numbers == "") {
      	this.$refs.order_number_ref?.focus();
        this.$Utils.showTipInfo("請輸入快遞單號");
        return;
      }
      if (form.recipient_phone == "") {
      	this.$refs.phone_ref?.focus();
        this.$Utils.showTipInfo("請輸入澳門手機號或會員號碼");
        return;
      }

      //校验长宽高
      if (
        !this.is_pdd &&
        !this.packageSize1 &&
        !this.packageSize2 &&
        !this.form.long &&
        !this.form.wide &&
        !this.form.height
      ) {
      	this.$refs.packageSize1_ref?.focus();
        this.$Utils.showTipInfo("請輸入尺寸");
        return;
      }

      let long = form.long;
      let wide = form.wide;
      let height = form.height;

      if (!this.is_pdd) {
        if (!this.packageSize1 && !this.packageSize2) {
          if (!long || !wide || !height) {
            return this.$Utils.showTipInfo("請輸入長寬高");
          }
          const max = Math.max(Number(long), Number(wide), Number(height));
          if (max < 51) return this.$Utils.showTipInfo("輸入的尺寸不合規則");
        } else {
          const val = Number(this.packageSize1) || Number(this.packageSize2);
          if (!val || val === 0) {
            this.$Utils.showTipInfo("請輸入最長邊");
            return false;
          }

          if (!(val >= 1 && val <= 50)) {
            this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
            return false;
          }
        }
      } else {
        let flag = 0,
          flag2 = 0,
          flag3 = 0;
        if (this.packageSize1) {
          flag = this.packageSize1;
          if (!(flag >= 1 && flag <= 50)) {
            this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
            return false;
          }
        } else if (this.packageSize2) {
          flag = this.packageSize2;
          if (!(flag >= 1 && flag <= 50)) {
            this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
            return false;
          }
        } else {
          flag = form.long;
          flag2 = form.wide;
          flag3 = form.height;

          if (flag && flag2 && flag3) {
            const max = Math.max(Number(flag), Number(flag2), Number(flag3));
            if (max < 51) return this.$Utils.showTipInfo("輸入的尺寸不合規則");
          }
        }
      }

      if (form.detailed_name == "") {
        this.$Utils.showTipInfo("請選擇快件明細");
        return;
      }
      if (form.recipient_contacts == "") {
        this.$Utils.showTipInfo("請輸入客戶名稱");
        return;
      }
      if (form.arrive == "" && form.arrive_cabinet == "") {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == null && form.arrive_cabinet == null) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == undefined && form.arrive_cabinet == undefined) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      // this.print_war();
      // 入库
      this.handleCheckForm();
    },
    onDeliverListSelectOpenChange(open) {
      this.deliverListSelectOpened = open;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .ivu-table-small td {
  height: auto;
  line-height: 1.4;
}

::v-deep th .ivu-table-cell {
  line-height: 1.5;
}

::v-deep .ivu-btn {
  height: 24px;
  font-size: 12px;
}
</style>
<style lang="scss" scoped>
@import "ScanIn.scss";
</style>
